import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4/segmentation`, {
  get: {
    'segmentations.get': '',
    'segmentation.get': '/:id'
  },
  post: {
    'segmentation.create': ''
  },
  put: {
    'segmentation.update': '/:id',
    'segmentation.rename': '/:id/rename'
  },
  delete: {
    'segmentation.delete': '/:id'
  }
});
